import { Box, BoxProps } from "@mui/material";
import React, { ReactNode } from "react";

type ScrollBarProps = {
  children: ReactNode;
  noWrap?: boolean;
  enableHorizontalScroll?: boolean;
} & BoxProps;

const ScrollArea: React.FC<ScrollBarProps> = ({ children, ...others }) => (
  <Box
    {...others}
    height={others?.height ?? "100vh"}
    sx={{
      overflowY: "overlay",
      overflowX: "hidden",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
    }}
  >
    {children}
  </Box>
);

export { ScrollArea };
